import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Faqs = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [Faqs, setFaqs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('asc');
    const [newCategory, setNewCategory] = useState("");
    const [answer, setAnswer] = useState("");
    const [question, setQuestion] = useState("");
    const [viewTitle, setViewTitle] = useState("");
    const [img, setImg] = useState("");
    const [viewStatus, setViewStatus] = useState("");
    const [viewID, setViewID] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [isPending, setIsPending] = useState(false);
    const [totalFaqs, setTotalFaqs] = useState(0);
    const [isFaqPending, setIsFaqPending] = useState(false);

    const sortedFaqs = sortOrder === 'asc' ? [...Faqs] : [...Faqs].reverse();
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentFaqs = sortedFaqs.slice(indexOfFirstItem, indexOfLastItem);

    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        fetchData();
        api.get(`${base_url}/faq/total-faqs/all`)
            .then((response) => {
                setTotalFaqs(response.data.result);
            })
            .catch((error) => {
                console.error("An error occurred:", error.response || error);
            });
    }, [currentPage]);

    const fetchData = async () => {
        setIsFaqPending(true);
        try {
            const response = await api.get(`${base_url}/faq/faq-by-page/10/${currentPage}`);
            setFaqs(response.data.result);
            setIsFaqPending(false);
        } catch (error) {
            console.error(error);
            setIsFaqPending(false);
        }
    };

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    const viewFaq = (img, title, status, id) => {
        setImg(img);
        setViewTitle(title);
        setViewStatus(status);
        setViewID(id);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsPending(true);
        const payload = {
            category: newCategory,
            question,
            answer
        };
        api.post(`${base_url}/faq/add-faq/`, payload)
            .then((response) => {
                setNewCategory("");
                setQuestion("");
                setAnswer("");
                addFaqsuccess("Faq Entry was successfully added");
                fetchData();
                setIsPending(false);
            })
            .catch((error) => {
                console.error(error);
                addFaqError(error.response.data);
                setIsPending(false);
            });
    };

    const handleSubmitStatusChange = (event) => {
        event.preventDefault();
        const payload = { status: selectedStatus };
        api.post(`${base_url}/campaign/change-status/${viewID}`, payload)
            .then((response) => {
                fetchData();
                changeStatusSuccess("Campaign status was successfully changed");
            })
            .catch((error) => {
                console.error(error);
                changeStatusError("An error occurred and we couldn't complete your request");
            });
    };

    const addFaqsuccess = (msg) => toast.success(msg, {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
    });

    const addFaqError = (msg) => toast.error(msg, {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
    });

    const changeStatusSuccess = (msg) => toast.success(msg, {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
    });

    const changeStatusError = (msg) => toast.error(msg, {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
    });

    const nextPage = () => {
        if (currentPage < Math.ceil(totalFaqs / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(totalFaqs / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(totalFaqs / itemsPerPage);
        const buttons = [];
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    return (
        <div>
            <div className="d-flex my-1">
                <div className="pt-3">
                    <h6 className="section-title">
                        <i className="bi bi-list"></i> Faqs
                        <small className="text-secondary" style={{ fontWeight: "400", fontSize: "smaller" }}> ({totalFaqs})</small>
                    </h6>
                </div>
                <div className="flex-fill text-end">
                    <button className="btn-custom" data-bs-toggle="modal" data-bs-target="#add-campaign">
                        <i className="bi bi-plus-circle"></i> Add
                    </button>
                    <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                        {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                    </button>
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-striped table-sm">
                    <thead className="table-dark">
                        <tr>
                            <th>ID</th>
                            <th>Category</th>
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isFaqPending ? (
                            <tr>
                                <td colSpan="5" className="text-center my-">
                                    <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                </td>
                            </tr>
                        ) : (
                            Faqs.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.category}</td>
                                    <td>{item.question}</td>
                                    <td>{item.answer}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                <div className="pagination btn-group">
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>
                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button>
                    {pageButtons()}
                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(totalFaqs / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>
                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(totalFaqs / itemsPerPage)}
                    >
                        Last
                    </button>
                </div>
            </div>
            <div className="modal fade" id="add-campaign">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-"></i> Add Campaign</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-basket"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} placeholder="Category" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-question-circle"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="Question" />
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-pencil"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={answer} onChange={(e) => setAnswer(e.target.value)} placeholder="Answer" />
                                    </div>
                                    {isPending ? (
                                        <button type="submit" className="btn-custom w-100 disabled-btn" disabled>
                                            <span>Processing </span><span className="spinner-border spinner-border-sm ms-2"></span>
                                        </button>
                                    ) : (
                                        <button type="submit" className="btn-custom w-100">Submit</button>
                                    )}
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="view-img">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-uppercase"><i className="bi-eye"></i> View Campaign</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="">
                                <img className="card-img-top" src={img} alt="" />
                                <div className="card-body p-3 py-4">
                                    <div className="d-flex">
                                        <div className="flex-fill shadow-sm m-1 p-3">
                                            <h6 className="card-title text-custom"><i className="bi-body-text"></i> Campaign Title</h6>
                                            <p className="card-text">{viewTitle}</p>
                                        </div>
                                        <div className="flex-fill shadow-sm m-1 p-3">
                                            <h6 className="card-title text-custom"><i className="bi-activity"></i> Current Status</h6>
                                            <p className="card-text">{viewStatus}</p>
                                        </div>
                                        <div className="flex-fill shadow-sm m-1 p-3">
                                            <form onSubmit={handleSubmitStatusChange}>
                                                <div className="input-group">
                                                    <select
                                                        className="form-select custom-input"
                                                        value={selectedStatus}
                                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                                    >
                                                        <option value="" className="bg-secondary">Select Status</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                        <option value="suspended">Suspended</option>
                                                        <option value="expired">Expired</option>
                                                    </select>
                                                    <button type="submit" className="btn-custom-sm ms-2">Change</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faqs;
